import { render, staticRenderFns } from "./Home_data.vue?vue&type=template&id=3b35d1b8&scoped=true&"
import script from "./Home_data.vue?vue&type=script&lang=js&"
export * from "./Home_data.vue?vue&type=script&lang=js&"
import style0 from "./Home_data.vue?vue&type=style&index=0&id=3b35d1b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b35d1b8",
  null
  
)

export default component.exports